import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M20 18.896c0 .61-.494 1.104-1.104 1.104h-4.612v-7.602h2.703l.404-2.963h-3.107V7.543c0-.857.252-1.442 1.555-1.442h1.662V3.45q-1.208-.12-2.422-.117c-2.395 0-4.035 1.38-4.035 3.916v2.185h-2.71v2.963h2.71V20h-9.94C.494 20 0 19.506 0 18.896V1.104C0 .494.494 0 1.104 0h17.792C19.506 0 20 .494 20 1.104z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }